import React from 'react';

export const NoStatisticsMessage = () => (
  <div className='message-stat'>
    <p>
      No statistics.
      <br />
      Statistics are saved when the "New game" button is pressed
    </p>
  </div>
);
